import { useRef, useEffect, FC } from "react";
import { classNames } from "primereact/utils";
import styles from "./DefaultInputField.module.scss";
import { AppTooltip } from "../../../tooltip/AppTooltip";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { useAppContext } from "../../../../../AppContext";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface CopyInputFieldProps {
  value: string;
  label?: string;
  tooltip?: string;
  placeholder?: string;
  width?: string;
  minWidth?: string;
  className?: string;
  autofocus?: boolean;
  disabled?: boolean;
}

export const CopyInputField: FC<CopyInputFieldProps> = ({
  value,
  label,
  tooltip,
  placeholder,
  width,
  minWidth,
  className,
  autofocus = false,
  disabled = false,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { isDesktopOrTablet } = useAppContext();

  useEffect(() => {
    if (autofocus) {
      inputRef.current?.focus();
    }
  }, [autofocus]);

  const handleClick = () => {
    inputRef.current?.select();
  };

  if (!width) {
    width = isDesktopOrTablet ? "600px" : dvSize("80dvw");
  }

  return (
    <div
      style={{ width: width, minWidth: minWidth, maxWidth: width }}
      className={classNames(className, styles.root, {
        [styles.root_disabled]: disabled,
      })}
      onClick={handleClick}
    >
      <RenderWhen condition={!!label}>
        <div
          className={classNames(styles.root_label, {
            [styles.root_label_interacted_with]: !!value,
          })}
        >
          {label}
          <AppTooltip content={tooltip} />
        </div>
      </RenderWhen>

      <div className={styles.root_input_container}>
        <input
          ref={inputRef}
          type="text"
          value={value}
          readOnly
          placeholder={placeholder}
          className={styles.root_input}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
